import ButtonType1 from "../../../../../../../commonreact/main/components/inputs/type1/ButtonType1"
import CSSClassSerivce from "../../../../../../../commonreact/main/services/CommonCSSSerivce"
import CardWrapper from "../../../../components/wrapper/card/CardWrapper"
import { IDeviceStateControllerReturn } from "../../../../../../../commonreact/main/services/devicestate/DeviceStateController"
import AppGUIElementsFactory from "../../../../factorys/AppGUIElementsFactory"
import { IServiceControllerReturn } from "../../ServiceController"
import { IEditBaseControllerReturn } from "../../../../controllers/EditBaseController"
import { EmailHoneyPot } from "../../../../../../../commonreact/main/components/emailhoneypot/EmailHoneyPot"
import { EmailHoneyPotController } from "../../../../../../../commonreact/main/components/emailhoneypot/EmailHoneyPotController"
import { Globals } from "../../../../../logic/services/Globals"
import InputValidationService from "../../../../../../../commonreact/main/factoryservices/inputvalidation/InputValidationService"
import { useNavigate } from "react-router-dom"
import { ERoute } from "../../../../routes/RoutesEnums"
import { ELng } from "../../../../../../../language/main/LanguageKeysEnums"
import { EDeviceScreenWidth } from "../../../../../../../commonreact/main/services/devicestate/DeviceStateEnums"
import { useTranslation } from "react-i18next"

interface IProps {
  msg?: string | null;
  dsc: IDeviceStateControllerReturn;
  sc: IServiceControllerReturn;
  appf: AppGUIElementsFactory;
  ebc: IEditBaseControllerReturn;
}

export const ServiceEmailCard: React.FC<IProps> = (props): JSX.Element => {

  const { t } = useTranslation();
  const navigate = useNavigate()

  //init controllers
  const hpc = EmailHoneyPotController({ rediredctUrl: Globals.baseWebUrl + "/thankyou" });

  const getWidth = (): string => {

    switch (props.dsc.eDeviceScreenState)
    {
      case EDeviceScreenWidth.ExtraLarge: return "w-[40rem]"
      case EDeviceScreenWidth.Large: return "w-[33rem]"
      case EDeviceScreenWidth.Medium: return "w-[27rem]"
      case EDeviceScreenWidth.Small: return "w-full";
      case EDeviceScreenWidth.Tiny: return "w-full";
      default: return "w-full";
    }
  }

  return (
    <CardWrapper
      dsc={props.dsc}
      header={<h1> t(ELng.service_email_header.valueOf())</h1>}
      hideHeader hideHeaderLine
    >

      <div className={`flex items-center ${getWidth()} m-auto pt-6 pb-6`}>
          <div className={`bg-gray-900 ${props.dsc.tiny?"pl-0 pr-0":"p-8"}  rounded-2xl w-full h-full border-gray-300 ${props.dsc.tiny?"border-none":"border-2"}`}>
            <h1 className="font-bold mb-6 text-center roboto-cond">{t(ELng.service_email_header_sub.valueOf())}</h1>
            <form>
              <div className="mb-4">
                {(props.sc.render) ? props.appf.getTextInputRequired({
                  id: "0",
                  testId: "test_subject",
                  required: true,
                  label: ELng.prop_email_subject.valueOf(),
                  placeholder: ELng.placeholder_common_subject.valueOf(),
                  v: props.sc.email?.subject,
                  onInputChange: (it) => { try { props.sc.email!!.subject = it } catch (e) { } },
                  fOnInputValidation: (it) => { try { props.sc.email!!.subjectVR.value = it } catch (e) { } },
                  ebc: props.ebc
                }, 8) : <></>}
              </div>
              <div className="mb-4">
                {(props.sc.render) ? props.appf.getTextInputRequired({
                  id: "1",
                  testId: "test_sender_name",
                  required: true,
                  label: ELng.prop_name.valueOf(),
                  placeholder: ELng.placeholder_common_name.valueOf(),
                  v: undefined,
                  onInputChange: (it) => { try { props.sc.email!!.senderName = it } catch (e) { } },
                  fOnInputValidation: (it) => { try { props.sc.email!!.senderNameVR.value = it } catch (e) { } },
                  ebc: props.ebc
                },3) : <></>}
              </div>
              <div className="mb-4">
                {(props.sc.render) ? props.appf.getTextInput({
                  id: "2",
                  testId: "test_sender_email",
                  required: true,
                  label: ELng.prop_email.valueOf(),
                  placeholder: ELng.placeholder_common_email.valueOf(),
                  v: undefined,
                  onInputChange: (it) => { try { props.sc.email!!.sender = it } catch (e) { } },
                  fOnInputValidation: (it) => { try { props.sc.email!!.senderVR.value = it } catch (e) { } },
                  ebc: props.ebc
                }) : <></>}
              </div>
              <div className="mb-4">
                {(props.sc.render) ? props.appf.getTextAreaInputRequired({
                  id: "3",
                  testId: "test_message",
                  classNameInput: CSSClassSerivce.textAreaReziseAbleInputClass,
                  required: true,
                  showLabel: true,
                  readOnly: false,
                  label: ELng.prop_email_message.valueOf(),
                  placeholder: ELng.placeholder_common_message.valueOf(),
                  v: undefined,
                  onInputChange: (it) => { try { props.sc.email!!.message = it } catch (e) { } },
                  fOnInputValidation: (it) => { try { props.sc.email!!.messageVR.value = it } catch (e) { } },
                  ebc: props.ebc
                }) : <></>}
              </div>
              <p className="text-gray-400 text-xs mb-4">{t(ELng.service_email_hint_required)}</p>

              <EmailHoneyPot hpc={hpc} />

              <div className="flex justify-center">
                <ButtonType1
                  testId ={"test_button_send"}
                  disabled={!props.sc.sendIsEnabled}
                  classNameInput={CSSClassSerivce.buttonCancelClass}
                  disabledAddClass={CSSClassSerivce.disabledAddClass}
                  onIsDisabledClick={() => InputValidationService.factory.dispatchGobalInputValidationEventvent()}
                  type={"button"}
                  onClick={() => {
                    if (hpc.isTriggered()) {
                      navigate(ERoute.RedirectToExternalThankYou);
                      return;
                    }
                    props.sc.sendEmail()
                  }}
                  caption={() => { return <>{t(ELng.service_email_send.valueOf())}</> }} 
                  />
                {/* <button type="submit" className="self-center border border-white py-2 px-6 rounded-full w-full md:max-w-80 inline-block text-center transition duration-300 hover:bg-white hover:text-black">
                  {t(ELng.service_email_send.valueOf())}
                  </button> */}
              </div>
            </form>
          </div>
     
      </div>


    </CardWrapper>
  )
}